export { default as homeownersImg } from './homeowners.svg';
export { default as petImg } from './pet.svg';
export { default as rentersImg } from './renters.svg';
export { default as termLifeImg } from './life.svg';
export { default as homeownersMobileImg } from './homeowners_mobile.svg';
